import { render, staticRenderFns } from "./PastReturnVisit.vue?vue&type=template&id=247fb842&"
import script from "./PastReturnVisit.vue?vue&type=script&lang=js&"
export * from "./PastReturnVisit.vue?vue&type=script&lang=js&"
import style0 from "./PastReturnVisit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports